export const NOUN = 'FORM'
export const RESET = 'RESET'
export const ENTER = 'ENTER'
export const EXIT = 'EXIT'
export const CANCEL = 'CANCEL'
export const UPDATE = 'UPDATE'
export const VALIDATE = 'VALIDATE'
export const SAVE = 'SAVE'
export const SAVE_COMPLETE = 'SAVE_COMPLETE'

export type FormPrefix = string
export type Verbs = string[]
export const verbs: Verbs = [
  ENTER,
  EXIT,
  CANCEL,
  UPDATE,
  RESET,
  SAVE,
  SAVE_COMPLETE,
  VALIDATE,
]



// WEBPACK FOOTER //
// ./src/components/form/constants.ts